import React, { useRef, useState, useEffect } from "react";
import VideoBox from "./VideoBox";
import NeonCard from "./NeonCard";
import {useApiManager} from "lib/ApiContext";
import { Box, IconButton, Stack } from "@mui/material";
const FeedList = ({loggedIn, isDirty, setErrorToShow, creator, setShowLogin}) => {
    const [publications, setPublications] = useState([]); 
  
    const api = useApiManager();

    const fetchData = async () =>{
        try {
            let data = null; 
            if (creator != undefined) 
                data = await api.GetPublicationsByCreator(creator); 
            else
                data = await api.GetPublications();
            if (data)
            {
                const validPosts = data.Publications.map(pub => ({
                    id: pub.PublicationID,
                    title: pub.Title,
                    creador: pub.Creator,
                    description: pub.Description,
                    publishType: Number(pub.PublishType), // <--- FORZAMOS a número
                    video: pub.VideoURL,
                    Likes: pub.Likes,
                    Comments: pub.Comments
                }));


                setPublications(validPosts);
               
                 console.log("✅ Publicaciones cargadas desde DynamoDB:", validPosts);
            }
                  
        } 
        catch (error) {
            console.error("❌ Error al cargar videos:", error);
            //setErrorToShow({ message: error.message, showError: true });
        }
      }

    useEffect(() => {
        //setIsDirty(false);
        fetchData();
        
    }, [isDirty, loggedIn]); 

      return (
        <Stack direction="column"
            spacing={2}
            sx={{
                justifyContent: "flex-start",
                alignItems: "center",
                position: "relative", 
                overflow: "hidden", 
                margin:2,
                marginTop:5,
            }}
        >
            {publications.map((post, index) => (
            <VideoBox
                key={index}
                loggedIn={loggedIn}
                publicationID={post.id}
                publishType={post.publishType}
                creador={post.creador}
                video={post.video}
                title={post.title}
                description={post.description}
                likes={post.Likes}
                comments={post.Comments}
                navigateTo={`publication/${post.id}`}
                setShowLogin={setShowLogin}
                sx={{
                padding: 0,
                margin: 0
                }}
            />
        
        ))}
        </Stack>
      );

};
export default FeedList;